import {
  getSitePermission,
  getWorkspacePermission,
} from '@packages/domains/authorization/permissions/client-permissions';
import type {WorkspacePermissions} from '@packages/domains/authorization/permissions/catalog';
import {abilityFeature} from '../abilityFeature';

function isWorkspaceResource(
  resource: string
): resource is keyof WorkspacePermissions {
  return resource.startsWith('workspace');
}

export const permissions = abilityFeature({
  key: 'permissions',
  isValid: function isPermissionsValid(state, permissionsToCheck) {
    if (!permissionsToCheck.length || !state.PermissionsStore) return true;

    return permissionsToCheck.every(([permissionKey, permissionType]) => {
      // Check if this is a workspace permission
      if (isWorkspaceResource(permissionType)) {
        return getWorkspacePermission(
          permissionKey,
          permissionType
        )(state.PermissionsStore);
      }
      // Otherwise treat as site permission
      return getSitePermission(
        permissionKey,
        permissionType
      )(state.PermissionsStore);
    });
  },
});
